import { render, staticRenderFns } from "./jiKaBind.vue?vue&type=template&id=4178f9e9&"
import script from "./jiKaBind.vue?vue&type=script&lang=js&"
export * from "./jiKaBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports